import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Container,
    TextField,
    Button,
    Stack,
    Alert
} from "@mui/material";
import excuseApi from "../../api/excuseApi";
import { getCurrentUser } from "../../models/Account";

export default function AccountSettings() {
    const [user, setUser] = useState(null);

    // info
    const [username, setUsername] = useState("");
    const [avatarFile, setAvatarFile] = useState(null);
    const [avatarPreview, setAvatarPreview] = useState(null);
    const [email, setEmail] = useState("");

    // password
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        getCurrentUser().then((u) => {
            setUser(u);
            setUsername(u?.username || "");
            setEmail(u?.email || "");
            setAvatarPreview(
                u?.avatar
                    ? `${process.env.REACT_APP_STATIC_URL}${u.avatar}`
                    : `https://ui-avatars.com/api/?name=${encodeURIComponent(u.username)}&background=random`
            );
        });
    }, []);

    const handleAvatarChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setAvatarFile(file);
        setAvatarPreview(URL.createObjectURL(file));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");
        setError("");

        if (newPassword && newPassword !== confirmPassword) {
            setError("Mật khẩu xác nhận không khớp");
            return;
        }

        const formData = new FormData();
        formData.append("username", username);
        if (avatarFile) formData.append("avatar", avatarFile);
        if (oldPassword && newPassword) {
            formData.append("oldPassword", oldPassword);
            formData.append("newPassword", newPassword);
        }

        try {
            await excuseApi({
                endpoint: "/update-profile",
                method: "POST",
                data: formData
            });

            setMessage("Cập nhật thông tin thành công");
            setOldPassword("");
            setNewPassword("");
            setConfirmPassword("");
            setAvatarFile(null);
        } catch (err) {
            setError(err?.error || err?.message || "Có lỗi xảy ra");
        }
    };

    if (!user) return null;

    return (
        <Container maxWidth="sm" sx={{ mt: 4, mb: 4 }}>
            <Typography variant="h5" gutterBottom>
                👤 Thay đổi thông tin cá nhân
            </Typography>

            <form onSubmit={handleSubmit}>
                <Stack spacing={2} sx={{ mb: 2 }}>
                    {message && <Alert severity="success">{message}</Alert>}
                    {error && <Alert severity="error">{error}</Alert>}
                </Stack>

                {/* Avatar */}
                <Box mb={2} textAlign="center">
                    <img
                        src={avatarPreview}
                        alt="Avatar preview"
                        style={{ width: 100, height: 100, borderRadius: "50%" }}
                    />
                    <Button component="label" sx={{ mt: 1 }}>
                        Thay ảnh đại diện
                        <input hidden type="file" accept="image/*" onChange={handleAvatarChange} />
                    </Button>
                </Box>

                {/* Username */}
                <TextField
                    label="Tên người dùng"
                    fullWidth
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    sx={{ mb: 3 }}
                />

                <TextField
                    label="Email"
                    fullWidth
                    value={email}
                    disabled
                    sx={{ mb: 2 }}
                />

                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    🔒 Đổi mật khẩu (bỏ trống nếu không muốn đổi)
                </Typography>

                <TextField
                    type="password"
                    label="Mật khẩu cũ"
                    fullWidth
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    sx={{ mb: 2 }}
                />
                <TextField
                    type="password"
                    label="Mật khẩu mới"
                    fullWidth
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    sx={{ mb: 2 }}
                />
                <TextField
                    type="password"
                    label="Xác nhận mật khẩu mới"
                    fullWidth
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    sx={{ mb: 2 }}
                />

                <Button variant="contained" type="submit" fullWidth>
                    Lưu thay đổi
                </Button>
            </form>
        </Container>
    );
}
